import { Menu, Row, Col, ConfigProvider, Drawer, Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import './Navbar.css';
import LanguageToggle from '../components/LanguageToggle';
import { useLanguage } from '../utils/LanguageContext';
import translations from '../components/ComponentsTranslations.lang.json';
import { ReactComponent as Logo } from '../images/logo_mediumGreen.svg';
import { Colors } from '../Colors';
import { useClientParams } from '../utils/AppConfigContext';

const Navbar = () => {
  const params = useClientParams();
  const { lang } = useLanguage(translations);
  const { isLoggedIn, logOut, user } = useAuth();

  const [isMobile, setIsMobile] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const onboardingComplete = isLoggedIn && user.onboardingComplete;

  const yourAccount = { key: 'yourAccount', label: <Link to="/account">{lang('yourAccount')}</Link> };
  const logout = {
    key: 'logout',
    label: (
      // in theory the to="/" is not needed, but for some reason the we get a react error on logout
      <Link to="/" onClick={logOut}>
        {lang('logout')}
      </Link>
    ),
  };
  const login = { key: 'login', label: <Link to="/login">{lang('login')}</Link> };
  const signup = { key: 'signup', label: <Link to="/signup">{lang('createAccount')}</Link> };
  const contactUs = { key: 'contactUs', label: <Link to="/contact">{lang('contactUs')}</Link> };
  const languageToggle = { key: 'languageToggle', label: <LanguageToggle /> };

  const varyingMenuItems = isLoggedIn ? [...(onboardingComplete ? [yourAccount] : []), logout] : [login, signup];

  const allMenuItems = [contactUs, ...(params.MARKETING_MODE ? [] : varyingMenuItems), languageToggle];

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: 'white',
          colorBgHeader: Colors.darkGreen,
          colorText: Colors.darkGreen,
        },
      }}
    >
      <Row justify="space-between" align="middle" className="navbar-row">
        <Col flex="none">
          <Link to="/" className="home-link">
            <Logo className="logo" />
          </Link>
        </Col>

        <Col flex="auto" className="menu-col">
          {isMobile ? (
            <>
              <Button
                className="hamburger-btn"
                type="text"
                icon={<MenuOutlined style={{ fontSize: '24px', color: Colors.darkGreen }} />}
                onClick={() => setDrawerVisible(true)}
              />
              <Drawer
                className="mobile-drawer"
                placement="right"
                width={240}
                closable={true}
                onClose={() => setDrawerVisible(false)}
                open={drawerVisible}
              >
                <Menu mode="vertical" items={allMenuItems} onClick={() => setDrawerVisible(false)} />
              </Drawer>
            </>
          ) : (
            <Menu
              mode="horizontal"
              items={allMenuItems}
              style={{
                minWidth: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                backgroundColor: 'transparent',
              }}
            />
          )}
        </Col>
      </Row>
    </ConfigProvider>
  );
};

export default Navbar;
